import React, {memo} from 'react';

import {_} from 'utils/i18n';

import Button from 'scripts/components/Button';

const Label = _('Back');
const Style = {padding: '0 5px'};

const CancelButton = props => (
    <Button {...props} className="modal-action modal-close" style={Style} flat>
        {Label}
    </Button>
);

export default memo(CancelButton);



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/CancelButton.js